import { KText } from '@/ui-library/components';
import {
  CandidateName,
  Department,
  EmployeeName,
  HiringManager,
  JobName,
  Nps,
  Recruiter,
  SurveyName,
} from '../cells/SurveyDrilldownCells';

const renderDrilldownHeader = (title: string) => () => (
  <KText size="sm-medium" color="secondary-900" textTransform="none">
    {title}
  </KText>
);

const HM_NPS_DRILLDOWN_HEADINGS = ['HM NPS over time', 'HM NPS'] as const;

const getBaseColumns = (columnsMap: Record<string, object>) => [
  columnsMap.candidateName,
  columnsMap.nps,
  columnsMap.surveyName,
  columnsMap.jobName,
  columnsMap.recruiter,
  columnsMap.hiringManager,
  columnsMap.department,
];

const getHMNpsColumns = (columnsMap: Record<string, object>) => [
  columnsMap.employeeName,
  ...getBaseColumns(columnsMap),
];

export const useSurveyDrilldownConfig = ({
  drilldownHeading = 'Survey',
  onSort: _onSort = () => {},
  currentSort: _currentSort = {},
}) => {
  const getColumnConfig = () => {
    const columnsMap = {
      candidateName: {
        title: 'Candidate name',
        columnConfig: false,
        Header: renderDrilldownHeader('Candidate name'),
        width: 200,
        accessor: 'candidate_name',
        sort: true,
        filterable: true,
        Cell: ({ row }) => CandidateName(row),
      },
      employeeName: {
        title: 'Employee name',
        Header: renderDrilldownHeader('Employee name'),
        width: 200,
        accessor: 'hm_name',
        sort: true,
        filterable: true,
        Cell: ({ row }) => EmployeeName(row),
      },
      jobName: {
        title: 'Job name',
        Header: renderDrilldownHeader('Job name'),
        width: 200,
        accessor: 'job_name',
        sort: true,
        filterable: true,
        Cell: ({ row }) => JobName(row),
      },
      hiringManager: {
        title: 'Primary hiring manager',
        Header: renderDrilldownHeader('Primary hiring manager'),
        width: 230,
        accessor: 'primary_hm',
        sort: true,
        filterable: true,
        Cell: ({ row }) => HiringManager(row),
      },
      recruiter: {
        title: 'Primary recruiter',
        Header: renderDrilldownHeader('Primary recruiter'),
        width: 200,
        accessor: 'primary_recruiter',
        sort: true,
        filterable: true,
        Cell: ({ row }) => Recruiter(row),
      },
      department: {
        title: 'Department',
        Header: renderDrilldownHeader('Department'),
        width: 200,
        accessor: 'department',
        sort: true,
        filterable: true,
        Cell: ({ row }) => Department(row),
      },
      nps: {
        title: 'NPS',
        Header: renderDrilldownHeader('NPS'),
        width: 100,
        accessor: 'nps',
        sort: true,
        filterable: true,
        Cell: ({ row }) => Nps(row),
      },
      surveyName: {
        title: 'Survey name',
        Header: renderDrilldownHeader('Survey name'),
        width: 200,
        accessor: 'survey_name',
        sort: true,
        filterable: true,
        Cell: ({ row }) => SurveyName(row),
      },
    };

    if (
      (HM_NPS_DRILLDOWN_HEADINGS as readonly string[]).includes(
        drilldownHeading
      )
    ) {
      return getHMNpsColumns(columnsMap);
    }

    return getBaseColumns(columnsMap);
  };

  return { columnConfig: getColumnConfig() };
};
